import React from 'react';
import { VirtualSessionIcon } from '@bizzabo/icons';
import LiveSessionPreviewImage from '../VirtualSessions/LiveSessionPreviewImage';
import { isMobile } from '../sessionBroadcastUtils';
import FeatureToggleUtils from 'FeatureToggleUtils';
import { NewRowWrapper as NewRowWrapperPlayer } from '@bizzabo/broadcast';

const NewRowWrapper = ({
    iframeUrl,
    recordingImageUrl,
    isIframeLoading,
    setIsIframeLoading,
    setRedirectModalVisibility,
}) => {
    const isInteractRingEnabled = FeatureToggleUtils.isFeatureEnabled('broadcastPlayerInteract');

    const isMobileDevice = isMobile();
    return isMobileDevice ? (
        <>
            <div className="color-1-background-opacity bz-flex-row">
                <button
                    className="join-broadcast-btn bz-button font-size-12 custom-color color-1-background color-1-hover-opacity external-solution-btn"
                    onClick={() => setRedirectModalVisibility(true)}
                >
                    <VirtualSessionIcon
                        className="broadcast-icon"
                        fill="#ffffff"
                        fontSize="20px"
                    />
                    <span>Join broadcast</span>
                </button>
            </div>
            <div className="live-broadcast-preview">
                {recordingImageUrl && (
                    <LiveSessionPreviewImage previewUrl={recordingImageUrl} />
                )}
            </div>
        </>
    ) : (
        <div className="make-relative iframe-broadcast-container">
            {isIframeLoading && (
                <i className="iframe-broadcast-spinner fa fa-spinner fa-spin fa-2x"/>
            )}
            {
                isInteractRingEnabled ?
                    <NewRowWrapperPlayer
                        src={iframeUrl}
                        onLoad={() => setIsIframeLoading(false)}
                        frameBorder={isIframeLoading ? '0' : null}
                    /> :
                    <iframe
                        src={iframeUrl}
                        onLoad={() => setIsIframeLoading(false)}
                        frameBorder={isIframeLoading ? '0' : null}
                        width="100%"
                        height="100%"
                        wmode="transparent"
                        allow="microphone *; camera *; speakers *; usermedia *; autoplay *; fullscreen *; display-capture *;"
                        className="kaltura-iframe"
                        // this deprecated property need to support firefox
                        // eslint-disable-next-line
                        allowFullScreen
                    />
            }
        </div>
    );
};

export default NewRowWrapper;
